<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "remove-member-modal",
    },

    // The member ID possibly being removed
    memberId: {
      type: String,
      required: true,
    },
  },

  computed: {
    // The member to remove
    member() {
      return this.teamMembers[this.memberId];
    },

    // Mapped vuex state
    ...mapState(["teamMembers"]),
  },

  methods: {
    // Remove the member, hide the modal, and go to the members page
    async remove() {
      let success = await this.removeTeamMember({ memberId: this.memberId });
      if (success) {
        this.hide();
        this.$router.push("/team/members");
      }
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["removeTeamMember"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Confirm Remove"
    button-size="sm"
    hide-header-close
  >
    <p v-if="member">
      Are you sure you want to remove
      <b>{{ member.name || "@" + member.handle }}</b>
      from the team?
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="danger" @click="remove">Remove Member</b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
